<div class="p-r h-100 w-100">
  @let selectedMarker = selectedMarker$ | async;
  <div class="search-input flex-row gap-8 start-center">
    <div class="map-search-fields flex-row gap-8 start-center">
      <div class="map-search-input-wrapper">
        <span class="ui-icon-search map-search-input-icon"></span>
        <input
          type="text"
          class="map-search-input-field"
          [placeholder]="'MAP.PLACEHOLDER' | translate"
          [formControl]="nameControl"
          [matAutocomplete]="nameAuto"
          (blur)="onObjectBlur()"
        />

        <mat-autocomplete
          #nameAuto="matAutocomplete"
          class="map-light-autocomplete-panel--app-map"
          (optionSelected)="onObjectSelected($event.option.value)"
          [displayWith]="displayObjectName.bind(this)"
        >
          @for (object of filteredObjects$ | async; track object.a) {
            <mat-option [value]="object.b">
              <span>{{ object.b }}</span>
            </mat-option>
          }
        </mat-autocomplete>
      </div>
      <span (click)="clean()" [matTooltip]="'COMMON.CLEAR' | translate" class="ui-icon-close c-p"></span>
    </div>
  </div>
  <google-map
    #googleMap
    [center]="defaultCoords()"
    [zoom]="5"
    height="100%"
    mapId="cbb640a7be456708"
    width="100%"
  >
    <map-info-window class="map-info">
      @if (selectedMarker) {
        <div class="flex-row end-center icon-container">
          <span class="ui-icon-cross cross-icon c-p" (click)="closeInfo()"></span>
        </div>
        <div class="image-container">
          @if (!selectLoading()) {
            <img [src]="selectMarkerPicture()"
                 class="marker-img"
                 [alt]="'MAP.ALT_IMAGE' | translate">
          } @else {
            <ui-preloader [color]="loaderColor.blue"></ui-preloader>
          }
        </div>
        <div class="flex-col gap-8 info">
          <div class="marker-name">
            {{ selectedMarker.b }}
          </div>
          <div>
            {{ selectedMarker.c }}, {{ selectedMarker.d }}
          </div>
          <div>
            {{ selectedMarker.a }}
          </div>
        </div>
      }
    </map-info-window>
  </google-map>
  @if (isLoading()) {
    <div class="fullscreen-preloader">
      <ui-preloader [color]="loaderColor.blue"></ui-preloader>
    </div>
  }
</div>
